module.exports = __webpack_public_path__ + "media/application/images/svgs/send-4415afea6358f49217e07d58c198517d.svg";